<template>
    <div :class="['tenjityModule-profil tenjityModule-item tenjityModule-item-profil', { 'tenjityModule-item-userProfil': profilType === 'user' }]"
        @click.prevent="handleClick">
        <div class="tenjityModule-profil-left">
            <AccessibilitySwitch :isChecked="isChecked" />
            <div role="button" class="tenjityModule-profil-name">{{ profil }}</div>
        </div>
        <div class="tenjityModule-profil-right">
            <Icon v-if="chevron && isChecked" @click.stop="$emit('handleToggleSubitems')"
                class="tenjityModule-item-icon tenjityModule-profil-chevron"
                :class="{ 'tenjityModule-profil-chevron-open': isSubitemsOpen }" icon="fluent:chevron-down-12-filled"
                role="button" :aria-label="isSubitemsOpen ? 'Réduire' : 'Développer'" />
            <Icon v-if="profilType === 'app'" class="tenjityModule-item-icon tenjityModule-item-icon-profil"
                :icon="icon" />
            <Icon v-if="profilType === 'user'" class="tenjityModule-item-icon tenjityModule-item-icon-delete"
                @click.stop="$emit('handleDelete')" :icon="icon" />
        </div>
    </div>
</template>

<script>
import { Icon } from "@iconify/vue";
import AccessibilitySwitch from "./AccessibilitySwitch.vue";

export default {
    name: "AccessibilityToggleProfil",
    components: {
        Icon,
        AccessibilitySwitch,
    },
    props: {
        profil: String,
        isChecked: Boolean,
        icon: String,
        profilType: String,
        chevron: { type: Boolean, default: false },
        isSubitemsOpen: { type: Boolean, default: true },
    },
    emits: ["handleClick", "handleDelete", "handleToggleSubitems"],
    methods: {
        handleClick() {
            this.$emit("handleClick");
            if (this.chevron && !this.isChecked) {
                this.$emit("handleToggleSubitems");
            }
        },
    },
};
</script>
